import * as React from 'react';
import InlineLoader from '../common/InlineLoader';
import './loading-app.scss';

export default class LoadingPage extends React.Component {
    render(): JSX.Element {
        return (
            <div className="loading-app">
                <InlineLoader className="loader-multipass" />
            </div>
        );
    }
}
